import { useEffect, useRef } from 'react';

/**
 * Debounced search: runs loadFn when searchTerm changes, with a delay.
 * On initial mount, runs loadFn immediately (no delay).
 * Use for list pages: search-as-you-type, no Search/Refresh buttons needed.
 *
 * @param {string} searchTerm - Current search input value
 * @param {function} loadFn - () => void, typically loadPage(1)
 * @param {number} delayMs - Debounce delay (default 300)
 */
export function useDebouncedSearch(searchTerm, loadFn, delayMs = 300) {
  const isInitialMount = useRef(true);
  const loadFnRef = useRef(loadFn);
  loadFnRef.current = loadFn;

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      loadFnRef.current();
      return;
    }
    const t = setTimeout(() => loadFnRef.current(), delayMs);
    return () => clearTimeout(t);
  }, [searchTerm, delayMs]);
}
